class RollIcon extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback(){
    this.init()
  }
  init(){
    if(document.documentElement.clientWidth > 749 && !this.classList.contains('roll-icon-2') || this.dataset.type == 'animate' || document.documentElement.clientWidth > 791 && this.classList.contains('roll-icon-2')) return;
    setTimeout(()=>{
      new Swiper(`.roll-icon-swiper-${this.dataset.sectionId}`,{
        loop:true,
        autoplay:{
          delay: 5000,
          stopOnLastSlide: false,
          disableOnInteraction: false,
        }
      })
    },1000)
  }
}
customElements.define('roll-icon', RollIcon);